module.exports = __webpack_public_path__ + "img/building.a413974f.png";